import React, { useEffect, useRef, useState } from 'react';

/* Водяной знак «не оплачен» поверх всего сайта приглашения.
   Показывается только на реальном опубликованном сайте, когда проект
   НЕ оплачен. В превью (чат-бот / конструктор) скрыт — определяем по
   пропу isPreview и по контейнеру превью среди предков.
   Стили — инлайн, без отдельного CSS-файла. */
export default function PaidWatermark({ isPaid, isPreview = false }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    if (isPaid) { setShow(false); return; }
    const el = ref.current;
    const inPreview = isPreview || !!(el && el.closest(
      '.lp-phone-screen,.lp-template-inner,.cb-preview,.cb-mobile-dock,.cb-preview-stage,[class*="lp-"]'
    ));
    setShow(!inPreview);
    if (typeof window !== 'undefined') setCompact(window.innerWidth <= 600);
  }, [isPaid, isPreview]);

  if (isPaid) return null;

  const overlayStyle = {
    position: 'fixed',
    inset: 0,
    zIndex: 2147483000,        // выше любых fixed-CTA шаблонов
    pointerEvents: 'none',
    overflow: 'hidden',
  };
  const tilesStyle = {
    position: 'absolute',
    top: '-50%',
    left: '-50%',
    width: '200%',
    height: '200%',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'center',
    justifyContent: 'center',
    gap: compact ? '20px 34px' : '26px 46px',
    transform: 'rotate(-30deg)',
  };
  const textStyle = {
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontWeight: 800,
    fontSize: compact ? 16 : 22,
    lineHeight: 1,
    color: 'rgba(220, 20, 60, 0.16)',
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    userSelect: 'none',
  };

  return (
    <div ref={ref} aria-hidden="true" style={show ? overlayStyle : { display: 'none' }}>
      {show && (
        <div style={tilesStyle}>
          {Array.from({ length: 400 }).map((_, i) => (
            <span key={i} style={textStyle}>не оплачен</span>
          ))}
        </div>
      )}
    </div>
  );
}
